import appendQuery from 'append-query'
import { RequestGet } from '../apiClient/api/RequestService'
import { refreshToken } from './RefreshToken'

function loadStart(){
    return { type : "LOAD" }
}
function loadSuccess(trans, totalTran, totalIncome, totalAllStatus){
    return { type : "LOAD_SUCCESS", transactions: trans, totalTran: totalTran, totalIncome: totalIncome, totalAllStatus: totalAllStatus}
}
function loadFail(){
    return { type : "LOAD_FAIL" }
}

export function loadTran(app_id, branch_id, store_id, cashier_id, from,to, dataToken, page_size = 10, page_index = 1, status = 0){
    return async dispatch => {
        dispatch(loadStart())
        const res = await RequestGet(appendQuery(`/v1/transactions`, {app_id, branch_id, store_id, cashier_id, from, to, page_size, page_index, status}), { token: dataToken.access_token })
        if (res?.return_code === 1) {
            dispatch(loadSuccess(res.data.transaction, res.data.total, res.data.total_income, res.data.total_all_status));
        } else if (res.sub_return_code === 3021) {
            dispatch(refreshToken(dataToken))
        } 
        else {
            dispatch(loadFail())
        }
    }
}

export async function loadTranWithouPagination(app_id, branch_id, store_id, cashier_id, from, to, dataToken, status = 0){
    const res = await RequestGet(appendQuery(`/v1/transactions`, {app_id, branch_id, store_id, cashier_id, from, to, status}), { token: dataToken.access_token })
    if (res.return_code === 1) {
        return res.data
    } else if (res.sub_return_code === 3021) {
        return res
    } 

}
